import React from 'react';
import './Footer.css';
import footerDocliveLogo from '../assets/doclivo-white.png'
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faInstagram } from '@fortawesome/free-brands-svg-icons'; // Import the icons you need
//import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons';

const Footer = () => {

  const navigate = useNavigate();

  const handleRedirectToAbout = () => {
    navigate('/about', { state: { scrollToSolutions: true } });
  };

  return (
    <footer id="footer" className="footer">

      <hr className="footer-line" />

      <div className="footer-columns">
        <div className="footer-column">
          <img src={footerDocliveLogo} alt="Footer Logo" className="footer-logo"></img>
          <h3 className="address-heading">Contact us</h3>
          <p className="address">501, Dnyanvatsal Corner, Opposite To Vandevi Mandir,
            Karve Nagar, Pune, Maharashtra - 411052.<br />
            <a href="tel:+917387893638"
              style={{ textDecoration: 'none', color: '#fff' }}
              className="phone-link">+91 738 789 3638
            </a>
          </p>
        </div>

        <div className="footer-column">
          <h3>Who We’re For</h3>
          <ul>
            <li><a href="/for-independent-practices">Independent practices</a></li>
            <li><a href="/for-new-practices">New practices</a></li>
            <li><a href="/for-consultant-physicians">Specialties</a></li>
            <li><a href="/for-patients">Patients</a></li>
            <li><a href="/for-ca">CAs</a></li>
          </ul>
        </div>

        <div className="footer-column">
          <h3>Products</h3>
          <ul>
            <li><a href="/emr">EMR</a></li>
            <li><a href="/digital-footprint">Digital Footprint</a></li>
            <li><a href="/digital-outreach">Digital Outreach</a></li>
            <li><a href="/billing-and-payments">Billing & Payments</a></li>
            <li><a href="/data-and-insights">Data & Insights</a></li>
          </ul>
        </div>

        <div className="footer-column">
          <h3>Why Doclivo</h3>
          <ul>
            <li><a href="/about" onClick={handleRedirectToAbout}>Manage records digitally</a></li>
            <li><a href="/about" onClick={handleRedirectToAbout}>Attract more patients</a></li>
            <li><a href="/about" onClick={handleRedirectToAbout}>Manage your reputation</a></li>
            <li><a href="/about" onClick={handleRedirectToAbout}>Automate your practice</a></li>
            <li><a href="about" onClick={handleRedirectToAbout}>Deliver better care</a></li>
            <li><a href="/about" onClick={handleRedirectToAbout}>Get paid faster</a></li>
            <li><a href="/about" onClick={handleRedirectToAbout}>Gain deeper insights</a></li>
            <li><a href="/about" onClick={handleRedirectToAbout}>Deliver better care</a></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-left">
        <p>&copy; {new Date().getFullYear()} Doclivo. All rights reserved.</p>

        </div>

        {/* <div className="footer-social-icons">
          <a href="https://www.facebook.com/profile.php?id=61556555573397" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <FontAwesomeIcon icon={faFacebookF} />
          </a>
          <a href="https://www.instagram.com/doclivo?igsh=ejl1Z29neGZscWN3" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <FontAwesomeIcon icon={faInstagram} />
          </a>
          <a href="https://twitter.com" target="_blank" >
            <i class="fab fa-x-twitter"></i>
          </a>
        </div> */}
      </div>
    </footer>
  );
};

export default Footer;
